(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffc-order-document-generator"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_PREFIX = 'odg-draft-';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function money(value, currency) {
    var number = Number(value || 0);
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency || 'GBP'
      }).format(number);
    } catch (error) {
      return number.toFixed(2) + ' ' + (currency || '');
    }
  }

  function todayPlus(days) {
    var date = new Date();
    date.setDate(date.getDate() + days);
    return date.toISOString().slice(0, 10);
  }

  function parseSizes(value) {
    return String(value || '')
      .split(',')
      .map(function (item) {
        var parts = item.split(':');
        return {
          size: (parts[0] || '').trim(),
          qty: (parts[1] || '').trim()
        };
      })
      .filter(function (item) {
        return item.size;
      });
  }

  function defaultDecorations() {
    return [
      {
        location: 'front',
        label: 'Left chest',
        process: 'DTF',
        width: '90',
        height: '52',
        offset: '72 mm from centre, 105 mm from collar',
        artwork: 'NORTHLINE LOGISTICS'
      },
      {
        location: 'back',
        label: 'Back',
        process: 'DTF',
        width: '280',
        height: '180',
        offset: 'Centered, 140 mm from collar',
        artwork: 'NORTHLINE LOGISTICS'
      },
      {
        location: 'sleeve',
        label: 'Right sleeve',
        process: 'Embroidery',
        width: '65',
        height: '35',
        offset: 'Per employee initials list',
        artwork: 'Initials'
      }
    ];
  }

  function getDefaults(root) {
    var node = root.querySelector('[data-odg-defaults]');
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function shirtSvg(back) {
    var neck = back ? '<path class="odg-shirt__detail" d="M49 9 H71"></path>' : '<path class="odg-shirt__detail" d="M50 8 C51 22 69 22 70 8"></path>';
    return [
      '<svg viewBox="0 0 120 150" role="img" aria-label="', back ? 'Garment back' : 'Garment front', '">',
      '<path class="odg-shirt__fill" d="M38 14 L50 8 H70 L82 14 L110 31 L101 61 L88 56 V136 H32 V56 L19 61 L10 31 Z"></path>',
      neck,
      '<path class="odg-shirt__detail" d="M32 56 L35 34 M88 56 L85 34"></path>',
      '</svg>'
    ].join('');
  }

  function areaHtml(decoration, areaClass) {
    if (!decoration) return '';
    var size = [decoration.width, decoration.height].filter(Boolean).join(' x ');
    return [
      '<span class="odg-shirt__area ', areaClass, '">',
      escapeHtml(decoration.label || decoration.location),
      size ? '<br>' + escapeHtml(size) : '',
      '</span>'
    ].join('');
  }

  function findDecoration(decorations, location) {
    return decorations.find(function (item) {
      return item.location === location;
    });
  }

  function garmentPair(data, stack) {
    var front = findDecoration(data.decorations, 'front') || findDecoration(data.decorations, 'chest');
    var back = findDecoration(data.decorations, 'back');
    var sleeve = findDecoration(data.decorations, 'sleeve');
    return [
      '<div class="odg-doc__shirt-pair ', stack ? 'odg-doc__shirt-pair--stack' : '', '">',
      '<div class="odg-shirt">',
      shirtSvg(false),
      areaHtml(front, 'odg-shirt__area--front'),
      areaHtml(sleeve, 'odg-shirt__area--sleeve'),
      '<span class="odg-shirt__label">Front</span>',
      '</div>',
      '<div class="odg-shirt">',
      shirtSvg(true),
      areaHtml(back, 'odg-shirt__area--back'),
      '<span class="odg-shirt__label">Back</span>',
      '</div>',
      '</div>'
    ].join('');
  }

  function documentHeader(data, title, statusColor) {
    return [
      '<header class="odg-doc__header" style="border-top: 8px solid ', escapeHtml(statusColor || data.primaryColor), '">',
      '<div class="odg-doc__brand">',
      '<span class="odg-doc__mark" style="background:', escapeHtml(data.primaryColor), '">', escapeHtml((data.storeName || 'US').slice(0, 2).toUpperCase()), '</span>',
      '<strong>', escapeHtml(data.storeName || 'FlexiFit Clothing'), '</strong>',
      '<span class="odg-doc__muted">', escapeHtml(data.brandEmail || ''), '<br>', escapeHtml(data.brandDomain || ''), '</span>',
      '</div>',
      '<div class="odg-doc__title">',
      '<h2>', escapeHtml(title), '</h2>',
      '<span class="odg-doc__pill" style="color:', escapeHtml(statusColor || '#25805b'), '">', escapeHtml(data.status), '</span>',
      '<p class="odg-doc__muted">ORDER ', escapeHtml(data.orderNumber), ' / ', escapeHtml(new Date().toLocaleDateString()), '</p>',
      '</div>',
      '</header>'
    ].join('');
  }

  function summaryGrid(data) {
    var subtotal = Number(data.quantity || 0) * Number(data.unitPrice || 0);
    var decoration = Number(data.decorationPrice || 0);
    var total = subtotal + decoration;
    return [
      '<div class="odg-doc__grid">',
      '<div class="odg-doc__box"><h3>Customer</h3><div class="odg-doc__kv">',
      '<div><span>Company</span><span>', escapeHtml(data.customerCompany), '</span></div>',
      '<div><span>Contact</span><span>', escapeHtml(data.contactPerson), '</span></div>',
      '<div><span>Email</span><span>', escapeHtml(data.customerEmail), '</span></div>',
      '</div></div>',
      '<div class="odg-doc__box"><h3>Schedule</h3><div class="odg-doc__kv">',
      '<div><span>Delivery</span><span>', escapeHtml(data.deliveryDate || 'TBC'), '</span></div>',
      '<div><span>Quantity</span><span>', escapeHtml(data.quantity), '</span></div>',
      '<div><span>Sizes</span><span>', escapeHtml(data.sizes), '</span></div>',
      '</div></div>',
      '<div class="odg-doc__box"><h3>Value</h3><div class="odg-doc__total">',
      '<div><span>Products</span><span>', money(subtotal, data.currency), '</span></div>',
      '<div><span>Decoration</span><span>', money(decoration, data.currency), '</span></div>',
      '<div><span>Total</span><span>', money(total, data.currency), '</span></div>',
      '</div></div>',
      '</div>'
    ].join('');
  }

  function sizeTable(data) {
    var rows = parseSizes(data.sizes);
    if (!rows.length) {
      rows = [{ size: 'Mixed', qty: data.quantity }];
    }
    return [
      '<table><thead><tr><th>Colour</th><th>Size</th><th>Qty</th><th>Unit</th></tr></thead><tbody>',
      rows.map(function (row) {
        return '<tr><td>' + escapeHtml(data.productColour) + '</td><td>' + escapeHtml(row.size) + '</td><td>' + escapeHtml(row.qty) + '</td><td>' + money(data.unitPrice, data.currency) + '</td></tr>';
      }).join(''),
      '</tbody></table>'
    ].join('');
  }

  function decorationCards(data) {
    return [
      '<div class="odg-doc__decorations">',
      data.decorations.map(function (item) {
        return [
          '<div class="odg-doc__decoration">',
          '<div class="odg-doc__mini">', escapeHtml(item.artwork || item.label), '</div>',
          '<h3>', escapeHtml(item.label), '</h3>',
          '<p class="odg-doc__muted">', escapeHtml(item.process), ', ', escapeHtml(item.width), ' x ', escapeHtml(item.height), ' mm. ', escapeHtml(item.offset), '</p>',
          '</div>'
        ].join('');
      }).join(''),
      '</div>'
    ].join('');
  }

  function productBlock(data, production) {
    return [
      '<section><h3>Product and decoration</h3>',
      '<div class="odg-doc__product ', production ? 'odg-doc__product--production' : '', '">',
      garmentPair(data, production),
      '<div>',
      '<div class="odg-doc__product-title"><strong>', escapeHtml(data.productName), '</strong><span class="odg-doc__process">', escapeHtml(data.decorations.map(function (item) { return item.process; }).filter(Boolean).join(' + ')), '</span></div>',
      sizeTable(data),
      '</div>',
      production ? '' : '<div class="odg-doc__total"><div><span>Line</span><span>#1</span></div><div><span>Qty</span><span>' + escapeHtml(data.quantity) + '</span></div><div><span>Total</span><span>' + money(Number(data.quantity || 0) * Number(data.unitPrice || 0) + Number(data.decorationPrice || 0), data.currency) + '</span></div></div>',
      '</div>',
      '</section>'
    ].join('');
  }

  function clientDocument(data) {
    return [
      documentHeader(data, 'Order summary', '#25805b'),
      '<div class="odg-doc__body">',
      summaryGrid(data),
      productBlock(data, false),
      '<section><h3>Decoration locations</h3>', decorationCards(data), '</section>',
      '<section><h3>Customer note</h3><div class="odg-doc__box">Please check product details, artwork placement and dimensions before approval.</div></section>',
      '</div>'
    ].join('');
  }

  function productionDocument(data) {
    return [
      documentHeader(data, 'Production card', '#b76b00'),
      '<div class="odg-doc__body">',
      '<div class="odg-doc__production-layout">',
      '<div>', productBlock(data, true), '</div>',
      '<aside class="odg-doc__box"><h3>Checklist</h3><div class="odg-doc__checklist">',
      '<span class="odg-doc__check">Check artwork colours</span>',
      '<span class="odg-doc__check">Run first item proof</span>',
      '<span class="odg-doc__check">Confirm garment size placement</span>',
      '<span class="odg-doc__check">QC first 5 pieces</span>',
      '</div><h3 style="margin-top:18px">Job code</h3><div class="odg-doc__barcode"></div><p class="odg-doc__muted">', escapeHtml(data.orderNumber), ' / Station DTF-2</p></aside>',
      '</div>',
      '<section><h3>Decoration files</h3><table><thead><tr><th>Process</th><th>Location</th><th>Artwork</th><th>Size</th></tr></thead><tbody>',
      data.decorations.map(function (item) {
        return '<tr><td>' + escapeHtml(item.process) + '</td><td>' + escapeHtml(item.label) + '</td><td>' + escapeHtml(item.artwork) + '</td><td>' + escapeHtml(item.width) + ' x ' + escapeHtml(item.height) + ' mm</td></tr>';
      }).join(''),
      '</tbody></table></section>',
      '<section><h3>Production notes</h3><div class="odg-doc__box">', escapeHtml(data.notes), '</div></section>',
      '</div>'
    ].join('');
  }

  function approvalDocument(data) {
    var primary = data.decorations[0] || {};
    return [
      documentHeader(data, 'Artwork approval', '#168579'),
      '<div class="odg-doc__body">',
      '<div class="odg-doc__proof">',
      '<div class="odg-doc__proof-art"><span class="odg-doc__measure odg-doc__measure--top">', escapeHtml(primary.width || ''), ' mm wide</span><span class="odg-doc__measure odg-doc__measure--left">', escapeHtml(primary.height || ''), ' mm high</span><div class="odg-doc__art-box">', escapeHtml(primary.artwork || 'Artwork'), '</div></div>',
      '<div class="odg-doc__box"><h3>Proof details</h3><div class="odg-doc__kv">',
      '<div><span>Product</span><span>', escapeHtml(data.productName), '</span></div>',
      '<div><span>Location</span><span>', escapeHtml(primary.label || ''), '</span></div>',
      '<div><span>Process</span><span>', escapeHtml(primary.process || ''), '</span></div>',
      '<div><span>Position</span><span>', escapeHtml(primary.offset || ''), '</span></div>',
      '<div><span>Order</span><span>', escapeHtml(data.orderNumber), '</span></div>',
      '</div></div>',
      '</div>',
      '<section><h3>Product views</h3>', decorationCards(data), '</section>',
      '<section><h3>Approval terms</h3><div class="odg-doc__box">After signature, artwork size, colour, content and placement are locked for production. Later changes require a new proof.</div><div class="odg-doc__signature"><div>Customer signature / date</div><div>Account manager / date</div></div></section>',
      '</div>'
    ].join('');
  }

  function readDecorations(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-odg-decoration]')).map(function (row) {
      return {
        location: row.querySelector('[name="decorationLocation"]').value,
        label: row.querySelector('[name="decorationLabel"]').value,
        process: row.querySelector('[name="decorationProcess"]').value,
        width: row.querySelector('[name="decorationWidth"]').value,
        height: row.querySelector('[name="decorationHeight"]').value,
        offset: row.querySelector('[name="decorationOffset"]').value,
        artwork: row.querySelector('[name="decorationArtwork"]').value
      };
    });
  }

  function readData(root, defaults) {
    var form = root.querySelector('[data-odg-form]');
    var data = Object.assign({}, defaults);
    Array.prototype.slice.call(form.elements).forEach(function (field) {
      if (!field.name || (field.name.indexOf('decoration') === 0 && field.name !== 'decorationPrice')) return;
      data[field.name] = field.value;
    });
    data.decorations = readDecorations(root);
    data.primaryColor = defaults.primaryColor || '#1f6feb';
    return data;
  }

  function writeForm(root, data) {
    Object.keys(data).forEach(function (key) {
      if (key === 'decorations') return;
      var field = root.querySelector('[name="' + key + '"]');
      if (field) field.value = data[key];
    });
    renderDecorationForm(root, data.decorations || defaultDecorations());
  }

  function renderDecorationForm(root, decorations) {
    var wrap = root.querySelector('[data-odg-decorations]');
    wrap.innerHTML = decorations.map(function (item, index) {
      return [
        '<div class="odg-decoration" data-odg-decoration>',
        '<div class="odg-decoration__head"><strong>Location ', index + 1, '</strong><button type="button" class="odg-decoration__remove" aria-label="Remove location" data-odg-action="remove-decoration">x</button></div>',
        '<div class="odg__fields odg__fields--two" style="padding:0">',
        '<label><span>View</span><select name="decorationLocation">',
        '<option value="front"', item.location === 'front' ? ' selected' : '', '>Front</option>',
        '<option value="back"', item.location === 'back' ? ' selected' : '', '>Back</option>',
        '<option value="sleeve"', item.location === 'sleeve' ? ' selected' : '', '>Sleeve</option>',
        '</select></label>',
        '<label><span>Label</span><input name="decorationLabel" type="text" value="', escapeHtml(item.label), '"></label>',
        '<label><span>Process</span><input name="decorationProcess" type="text" value="', escapeHtml(item.process), '"></label>',
        '<label><span>Artwork</span><input name="decorationArtwork" type="text" value="', escapeHtml(item.artwork), '"></label>',
        '<label><span>Width mm</span><input name="decorationWidth" type="number" min="1" value="', escapeHtml(item.width), '"></label>',
        '<label><span>Height mm</span><input name="decorationHeight" type="number" min="1" value="', escapeHtml(item.height), '"></label>',
        '</div>',
        '<label><span>Placement notes</span><input name="decorationOffset" type="text" value="', escapeHtml(item.offset), '"></label>',
        '</div>'
      ].join('');
    }).join('');
  }

  function currentType(root) {
    var active = root.querySelector('[data-odg-doc-type].is-active');
    return active ? active.getAttribute('data-odg-doc-type') : 'client';
  }

  function render(root) {
    var defaults = getDefaults(root);
    var data = readData(root, defaults);
    var type = currentType(root);
    var preview = root.querySelector('[data-odg-preview]');
    var title = root.querySelector('[data-odg-preview-title]');
    var html;

    if (type === 'production') {
      html = productionDocument(data);
      title.textContent = 'Production card';
    } else if (type === 'approval') {
      html = approvalDocument(data);
      title.textContent = 'Artwork approval';
    } else {
      html = clientDocument(data);
      title.textContent = 'Client summary';
    }

    preview.innerHTML = html;
    return { data: data, html: html, type: type };
  }

  function saveDraft(root) {
    var defaults = getDefaults(root);
    var data = readData(root, defaults);
    localStorage.setItem(STORAGE_PREFIX + root.getAttribute('data-section-id'), JSON.stringify(data));
    var state = root.querySelector('[data-odg-save-state]');
    if (state) state.textContent = 'Saved ' + new Date().toLocaleTimeString();
  }

  function loadDraft(root) {
    var raw = localStorage.getItem(STORAGE_PREFIX + root.getAttribute('data-section-id'));
    if (!raw) return false;
    try {
      writeForm(root, JSON.parse(raw));
      return true;
    } catch (error) {
      return false;
    }
  }

  function exportJson(root) {
    var data = readData(root, getDefaults(root));
    var blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = (data.orderNumber || 'order') + '-document-data.json';
    link.click();
    URL.revokeObjectURL(link.href);
  }

  function printDocument(root) {
    var rendered = render(root);
    var cssLink = document.querySelector('link[href*="order-document-generator.css"]');
    var styles = cssLink ? cssLink.outerHTML : '';
    var win = window.open('', '_blank', 'width=980,height=900');
    if (!win) return;
    win.document.write([
      '<!doctype html><html><head><title>', escapeHtml(rendered.data.orderNumber), ' document</title>',
      styles,
      '<style>body{margin:0;background:#ffffff}.odg{background:#ffffff;padding:0}.odg-doc{box-shadow:none;border:0;width:100%;max-width:780px;margin:0 auto}.odg-doc__header{break-inside:avoid}@page{size:A4;margin:12mm}button{display:none!important}</style>',
      '</head><body class="odg-print-root"><main class="odg"><article class="odg-doc">', rendered.html, '</article></main></body></html>'
    ].join(''));
    win.document.close();
    win.focus();
    setTimeout(function () {
      win.print();
    }, 250);
  }

  function bind(root) {
    var defaults = getDefaults(root);
    var delivery = root.querySelector('[name="deliveryDate"]');
    if (delivery && !delivery.value) delivery.value = todayPlus(7);
    renderDecorationForm(root, defaultDecorations());
    loadDraft(root);
    render(root);

    root.addEventListener('input', function () {
      var state = root.querySelector('[data-odg-save-state]');
      if (state) state.textContent = 'Unsaved changes';
      render(root);
    });

    root.addEventListener('change', function () {
      render(root);
    });

    root.addEventListener('click', function (event) {
      var typeButton = event.target.closest('[data-odg-doc-type]');
      var actionButton = event.target.closest('[data-odg-action]');
      if (typeButton && root.contains(typeButton)) {
        Array.prototype.slice.call(root.querySelectorAll('[data-odg-doc-type]')).forEach(function (button) {
          button.classList.toggle('is-active', button === typeButton);
        });
        render(root);
        return;
      }

      if (!actionButton || !root.contains(actionButton)) return;
      var action = actionButton.getAttribute('data-odg-action');
      if (action === 'add-decoration') {
        var data = readData(root, defaults);
        data.decorations.push({
          location: 'front',
          label: 'New location',
          process: 'DTF',
          width: '100',
          height: '60',
          offset: '',
          artwork: ''
        });
        renderDecorationForm(root, data.decorations);
        render(root);
      } else if (action === 'remove-decoration') {
        actionButton.closest('[data-odg-decoration]').remove();
        render(root);
      } else if (action === 'save') {
        saveDraft(root);
      } else if (action === 'export-json') {
        exportJson(root);
      } else if (action === 'clear') {
        localStorage.removeItem(STORAGE_PREFIX + root.getAttribute('data-section-id'));
        root.querySelector('[data-odg-form]').reset();
        if (delivery) delivery.value = todayPlus(7);
        renderDecorationForm(root, defaultDecorations());
        render(root);
      } else if (action === 'load-sample') {
        writeForm(root, {
          orderNumber: 'US-1048',
          status: 'Ready for approval',
          customerCompany: 'Northline Logistics',
          contactPerson: 'Anna Nowak',
          customerEmail: 'anna@example.com',
          deliveryDate: todayPlus(7),
          productName: 'Softshell Pro Jacket',
          productColour: 'Black / Navy',
          sizes: 'S:8, M:18, L:22, XL:12',
          quantity: '60',
          unitPrice: '49',
          decorationPrice: '680',
          notes: 'Chest logo must not cross the pocket seam. Back artwork centered to garment panel.',
          decorations: defaultDecorations()
        });
        render(root);
      } else if (action === 'print') {
        printDocument(root);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-order-document-generator]')).forEach(bind);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
